import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'binary',
    standalone: false
})
export class BinaryPipe implements PipeTransform {
  transform(value: boolean, { T = 'Yes', F = 'No' } = {}): string {
    return value ? T : F;
  }
}
